import axios from "axios";
import UserService from "rc-app/services/UserService";

const getProperties = () => {
  const API_URL =
    "https://realestate.dev.1verse.live/api/v1/realestate/views/mp_digital_twin?sort_by=created_at&sort_order=-1&page=0&limit=20";
  axios
    .get(API_URL, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      const temp = res.data.mp_digital_twin_list.map(
        (digital_twin) => digital_twin.matterport_id
      );
      setProperties(temp);
      console.log(res, "res");
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
};

// Business Admin / Client Manager
export const createClientManager = async (jsonData) => {
  try {
    console.log("create Client", jsonData);

    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/re_agency_business_admin`;
    const PAYLOAD = {
      ...jsonData,
    };

    const response = await axios.post(API_URL, PAYLOAD, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    throw error;
  }
};

export const editClientManager = async (jsonData, clientManagerId) => {
  try {
    console.log("create Client", jsonData);

    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/re_agency_business_admin/${clientManagerId}`;
    const PAYLOAD = {
      ...jsonData,
    };

    const response = await axios.put(API_URL, PAYLOAD, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    throw error;
  }
};

export const getClientManagerByEmailId = async (emailId) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_agency_business_admin/email/${emailId}`;

    const response = await fetch(API_URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching properties:", error);
    throw error;
  }
};

export const getClientAdminByEmailId = async (emailId) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_agency_system_admin/email/${emailId}`;

    const response = await fetch(API_URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching properties:", error);
    throw error;
  }
};


// System Admin / Client Admin
export const createClientAdmin = async (jsonData) => {
  try {
    console.log("create Client", jsonData);

    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/re_agency_system_admin`;
    const PAYLOAD = {
      ...jsonData,
    };

    const response = await axios.post(API_URL, PAYLOAD, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    throw error;
  }
};

export const editClientAdmin = async (jsonData, clientAdminId) => {
  try {
    console.log("create Client", jsonData);

    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/re_agency_system_admin/${clientAdminId}`;
    const PAYLOAD = {
      ...jsonData,
    };

    const response = await axios.put(API_URL, PAYLOAD, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    throw error;
  }
};



export const getClientAdminById = async (clientAdminId) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_agency_system_admin/${clientAdminId}`;

    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching properties:", error);
  }
};

// System Admin / Client Admin
export const getSystemAdminList = async (clientId) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_agency_system_admin/agency/${clientId}?page=0&limit=20`;

    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching properties:", error);
  }
};

export const getBusinessAdminList = async (clientId) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_agency_business_admin/agency/${clientId}?page=0&limit=20`;

    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching properties:", error);
  }
};


export const checkClientManagerEmailExists = async (email) => {
  try {
    const data = await getClientManagerByEmailId(email);
    return data?.agency_business_admin ? data.agency_business_admin : null;
  } catch (error) {
    return null;
  }
};

export const checkClientManagerMobileExists = async (mobile, agencyId) => {
  try {
    const data = await getBusinessAdminList(agencyId);
    const existingManager = data?.agency_business_admin_list?.find(
      (manager) => manager.mobile_number === mobile
    );
    return existingManager || null;
  } catch (error) {
    return null;
  }
};



export const checkClientAdminEmailExists = async (email) => {
  try {
    const data = await getClientAdminByEmailId(email);
    return !!data?.agency_system_admin;
  } catch (error) {
    return false;
  }
};

export const checkClientAdminMobileExists = async (mobile, agencyId) => {
  try {
    const data = await getSystemAdminList(agencyId);
    const existingAdmin = data?.agency_system_admin_list?.find(
      (admin) => admin.mobile_number === mobile
    );
    return existingAdmin || null;
  } catch (error) {
    return null;
  }
};


